import { render, staticRenderFns } from "./SizeDetailConf.vue?vue&type=template&id=bda5a216&"
import script from "./SizeDetailConf.vue?vue&type=script&lang=js&"
export * from "./SizeDetailConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports